import { render, staticRenderFns } from "./no-activities-card.vue?vue&type=template&id=0d992c01&scoped=true&"
import script from "./no-activities-card.vue?vue&type=script&lang=js&"
export * from "./no-activities-card.vue?vue&type=script&lang=js&"
import style0 from "./no-activities-card.vue?vue&type=style&index=0&id=0d992c01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d992c01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d992c01')) {
      api.createRecord('0d992c01', component.options)
    } else {
      api.reload('0d992c01', component.options)
    }
    module.hot.accept("./no-activities-card.vue?vue&type=template&id=0d992c01&scoped=true&", function () {
      api.rerender('0d992c01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/no-activities-card.vue"
export default component.exports